import React, { useEffect, useRef, useState } from 'react';
import { InputType } from '../../modules/authorization/authorization.type';
import { validationService } from '../../services/validationService';
import {
  formatDate,
  fourYearsFromToday,
  minDateForBirth,
} from '../../helpers/utils';
import CustomCalendar from '../customCalendar';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import cn from 'classnames';
import './styles.scss';

export const DateInput: React.FC<{ input: InputType; onChange: Function }> = ({
  input,
  onChange,
}) => {
  const { label, placeholder, disabled, validation, name } = input;
  const [inputValue, setInputValue] = useState<Date | null>(fourYearsFromToday);
  const inputRef = useRef<any>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (e: any) => {
    setInputValue(e);
    onChange(
      name,
      e,
      validationService[
        `${validation.type}Validation` as keyof typeof validationService
      ](e),
    );
  };

  useEffect(() => {
    handleChange(inputValue);
  }, []);

  useOnClickOutside(inputRef, () => setIsOpen(false));

  return (
    <div className="authInputWrp" ref={inputRef}>
      <div className="inputWrp" onClick={() => setIsOpen(!isOpen)}>
        <p className="inputText">{label}</p>
        <div
          className={`inputCase lg ${validation.status === false && 'error'} ${disabled && 'disabled'}`}
        >
          <span
            className={cn('input', 'date_input', {
              placeholder: !inputValue,
            })}
          >
            {inputValue ? formatDate(inputValue, 'dd/MM/yyyy') : placeholder}
          </span>
          <div className="authInputIconCase">
            <i className={cn('icon-calendar')} />
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="calendar_wrapper">
          <CustomCalendar
            currentDate={inputValue}
            setCurrentDate={handleChange}
            min={minDateForBirth}
            max={fourYearsFromToday}
            hasTodayBtn={false}
            hasTime={false}
          />
        </div>
      )}
      {validation.status === false && validation.error && (
        <p className="errorText">{validation.error}</p>
      )}
    </div>
  );
};
